<div class="video-player-container">
  <div class="video-header">
    <h2 class="video-title">{{ title }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-button" [attr.aria-label]="t.VideoPlayerCloseAria">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="video-wrapper">
    <!-- HTML5 Video Player for self-hosted videos -->
    <video
      #videoPlayer
      *ngIf="useHtml5"
      [src]="videoUrl"
      class="video-player"
      controls
      autoplay
      playsinline
      preload="metadata">
      {{ t.VideoPlayerNotSupported }}
    </video>

    <!-- YouTube iframe for YouTube videos -->
    <iframe
      *ngIf="!useHtml5"
      [src]="safeVideoUrl"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      class="video-iframe">
    </iframe>
  </div>
</div>
